import HeroBg from "public/internetAndDci/Network-Services_ internet and dci.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Compare Our Plans",
    link: "comparison",
  },
  button2: {
    label: "Contact Us",
    link: "contact-us",
  },
  title:
    "Uninterrupted Global Connectivity with Scalable Internet & Data Center Interconnect",
  desc: "Global, low-latency connectivity with scalable internet and data center links—engineered for performance and uptime.",
  image: HeroBg,
};
